import { render } from "./App1.vue?vue&type=template&id=5cbc94ae"
import script from "./App1.vue?vue&type=script&lang=js"
export * from "./App1.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__